import { createReducer, on } from '@ngrx/store';
import { studentsActions } from '../actions/students.actions';
import { Student } from '../models';

export interface StudentsState {
    loaded: boolean | null;
    loading: boolean | null;
    total: number | null;
    students: Student[] | null;
    pagination: Pagination | null;
}

interface Pagination {
    currentPage: number;
    limit: number;
}

export const initialState: StudentsState = {
    loaded: null,
    loading: null,
    total: null,
    students: null,
    pagination: null,
};

export const studentsReducer = createReducer(
    initialState,
    on(
        studentsActions.getStudents,
        (state, action): StudentsState => ({
            ...state,
            pagination: {
                currentPage: action.page,
                limit: action.limit,
            },
        }),
    ),
    on(
        studentsActions.getStudentsSuccess,
        (state, { payload }): StudentsState => ({
            ...state,
            loaded: true,
            total: payload.total,
            students: payload.items,
        }),
    ),
    on(
        studentsActions.getStudentsError,
        (state): StudentsState => ({
            ...state,
            loaded: false,
        }),
    ),
    on(
        studentsActions.clear,
        (): StudentsState => ({
            ...initialState,
        }),
    ),
);
